import { useMemo } from 'react';
import { usePluginStore, type WorkspacePluginSetting } from '@/stores/usePluginStore';
import { useWorkspaceStore } from '@/stores/useWorkspaceStore';

function isMachineAwareEnabled(settings: WorkspacePluginSetting[]): boolean {
  const ingestSettings = settings.find((setting) => setting.pluginId === 'ingest');
  return ingestSettings?.enabled !== false && ingestSettings?.settingsJson?.machine_aware === true;
}

export function useWorkspaceCapabilities() {
  const activeWorkspaceId = useWorkspaceStore((state) => state.activeWorkspace?.id ?? null);
  const workspaceSettings = usePluginStore((state) => state.workspaceSettings);
  const workspaceSettingsLoadedFor = usePluginStore((state) => state.workspaceSettingsLoadedFor);

  return useMemo(() => {
    const settingsLoaded = !activeWorkspaceId || workspaceSettingsLoadedFor === activeWorkspaceId;

    return {
      settingsLoaded,
      isMachineAware: settingsLoaded && isMachineAwareEnabled(workspaceSettings),
    };
  }, [activeWorkspaceId, workspaceSettings, workspaceSettingsLoadedFor]);
}